import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=ec7e0c10&scoped=true&"
import script from "./CalendarCard.vue?vue&type=script&lang=js&"
export * from "./CalendarCard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCard.vue?vue&type=style&index=0&id=ec7e0c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7e0c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
